// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Nav-module--navbar--2PP3l","nav":"Nav-module--nav--diVVf","title":"Nav-module--title--2ajg6","flex":"Nav-module--flex--1IGlO","logo":"Nav-module--logo--TkeDq"};